import { createFileRoute } from '@tanstack/react-router';
import { MfaPreferenceForm } from '../../components/me/MfaPreferenceForm';

export const Route = createFileRoute('/_authenticated/_layout/me/security/mfa-preference')({
    component: () => (
        <div className="space-y-4">
            <h1 className="text-2xl font-semibold">Preferencia MFA</h1>
            <MfaPreferenceForm />
        </div>
    ),
});
